<template>
  <header id="header" class="full">
    <div id="base-header">
      <div class="navbar px-5 py-1">
        <a
          v-if="!!affiliateCustomizations"
          :href="loginUrl" class="logo"
          :style="`background-image: url('${appNavLogo}');`">
        </a>
        <a v-else :href="loginUrl" class="logo"></a>
        <AppNav />
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from "~/store/affiliate-customization";
import { useIdentityStore } from '~/store/identity';

export default {
  name: 'TenantAppHeader',
  computed: {
    ...mapState(useAffiliateCustomizationStore, [
      'affiliateCustomizations',
      'appNavLogo',
    ]),
    ...mapState(useIdentityStore, [
      'loginUrl',
    ]),
  },
}
</script>

<style lang='scss' scoped>
@import 'assets/styles/affiliate-customizations/affiliate-customization-mixins';

#header {
  #base-header {
    @include affiliateAppAnchorTag();
    flex: 0 0 auto;
    margin: 0;
    background: #FFF;
    border: 1px solid #DADFE3;
    $navheight: 83px;
    height: $navheight;
    .navbar {
      height: 100%;
    }
    .logo {
      background-image: url('~/public/images/Lendio-Logo-2024.svg');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      min-width: 160px;
      height: $navheight - 30px;
    }
  }
}
</style>
